import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Grid, Button } from 'semantic-ui-react';

import { DateForm, SikdaeGroup, SikdaePolicy } from 'components/Commons';

class SikdaeGroupStatsForm extends Component {

  render() {

    const { sikdaeGroupVal,
            sikdaeGroup,
            sikdaeGroupSearch,
            sikdaePolicy,
            submitForm } = this.props.formFn;

    return(
      <Form className="top-form">
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={14}>
              <Form.Group>
                <DateForm />
              </Form.Group>
            </Grid.Column>
            <Grid.Column width={2} className="right">
              <Button
                color="black" inverted
                content='조회'
                onClick={submitForm}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              <Form.Group style={{marginBottom: 0}}>
                <SikdaeGroup
                  sikdaeGroup={sikdaeGroup}
                  sikdaeGroupSearch={sikdaeGroupSearch}
                />
                <SikdaePolicy
                  sikdaeGroupVal={sikdaeGroupVal}
                  sikdaePolicy={sikdaePolicy}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }

}

SikdaeGroupStatsForm = connect(
  state => ({

  })
)(SikdaeGroupStatsForm)

export default SikdaeGroupStatsForm;
